import { action } from 'satcheljs';
export var getPremiumUser = action('getPremiumUser');
//# sourceMappingURL=getPremiumUser.js.map